export const DUT_ACCORDION_SECTIONS = [
  {
    id: "general-findings",
    title: "General Findings",
    caseStage: "admission",
  },
  {
    id: "family-history",
    title: "Family History",
    caseStage: "admission",
  },
  {
    id: "personal-history",
    title: "Personal History",
    caseStage: "admission",
  },
  {
    id: "admission-details",
    title: "Admission Details",
    caseStage: "admission",
  },
  {
    id: "diagnosis",
    title: "Diagnosis",
    caseStage: "admission",
  },
  {
    id: "treatment-plan",
    title: "Treatment Plan",
    caseStage: "admission enhancement",
  },
  {
    id: "implants",
    title: "Implants",
    caseStage: "admission",
  },

  {
    id: "Amount-and-Incentive-Details",
    title: "Amount and Incentive Details",
    caseStage: "discharge",
  },
  {
    id: "hospital-details",
    title: "Hospital Bill Details",
    caseStage: "discharge",
  },
  {
    id: "claim-query-details",
    title: "Claim Query Details",
    caseStage: "claim",
  },
  {
    id: "investigation-documents",
    title: "Investigation / Documents",
    caseStage: "admission enhancement claim discharge",
  },
  {
    id: "care-team-details",
    title: "Care Team Details",
    caseStage: "admission",
  },

  {
    id: "stg-questionnaire",
    title: "STG Questionnaire",
  },
];
